import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["main", "thumbnail"]

    update(event) {
        // Update main image source
        const src = event.currentTarget.dataset.src
        this.mainTarget.src = src

        // Manage active state
        this.thumbnailTargets.forEach(el => el.classList.remove("ring-2", "ring-primary-500"))
        event.currentTarget.classList.add("ring-2", "ring-primary-500")
    }
}
